import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'getToFixed',
    pure: true
})
export class ToFixedPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        return this.getToFixed(value)
    }
    getToFixed(n: any): String {
        let toFloat = parseFloat(n);
        if (n != null && typeof(toFloat)=="number") {
            return toFloat.toFixed(2)
        } 
        else if(n!= null && typeof(toFloat)!= "number") {
            return n
        } else {
            return '';
        }
    }
}